export default function($form) {
  var $params=$form.getExtForm();
  if (!$form.isValid(true)) {
    return;
  }

  PF.api.process.getBindLeaderData($params.taskId).then(res=>{
    if(res.success){
      var leadData = res.result;
      if(!leadData || !leadData.flow){
        PF.message('info', '获取领导数据信息失败!');
        return;
      }
      var p ={
        taskId:$params.taskId,
        appId:$params.appId,
        formId:$params.formId,
        activity:$params.activity,
        ownerName:leadData.name
        //comment:$params.comment
      }
      if($params.extParams && $params.extParams.fullAuthType){
        p.fullAuthType = $params.extParams.fullAuthType;
      }
      PF.show('flowSecrecord',p, function(res){
        var comment = res.comment;
        let params = {};
        params.type = "virtualRecord";
        params.isAgentRecord = 1;
        //params.action='SECRECORD';
        params.actionDescription='秘书代录：'+comment;
        params.taskId=$params.taskId;
        params.appId=$params.appId;
        params.formId=$params.formId;

        var items=[];
        var item={};
        item.group=leadData.departmentId;
        item.users=[{id:leadData.id}];
        items.push(item);
        params.activities = [{activityId:leadData.activityId, items:items}];
        params.$comment=[{id:$uuid(), content:comment, category:$params.activity.commentCategory, leading:1, isAgentRecord:1, agentType:'SECRETARY'}];
        PF.api.process.saveVirtualRecord(params).then((res) => {
          $params.refreshComment(params);
        }).catch(() => {
          $params.refreshComment(params);
        });
      });
    }
  });
}



// WEBPACK FOOTER //
// ./src/common/components/extend/form/src/config/flow-spsecrecord.js